import { BaseIncidentFields } from './common';

export enum DisturbanceReason {
  NOISE = 'NOISE',
  ODOR = 'ODOR',
  VANDALISM = 'VANDALISM',
  THREATENING = 'THREATENING',
  SMOKING = 'SMOKING',
  LITTERING = 'LITTERING',
  PARKING = 'PARKING',
  OTHER = 'OTHER',
}

export enum DisturbanceLocation {
  COMMON = 'COMMON',
  APARTMENT = 'APARTMENT',
  OTHER = 'OTHER',
}

export interface DisturbanceIncidentRequest extends BaseIncidentFields {
  description: string;
  dateTime: string[];
  discussed: boolean;
  policeCalled: boolean;
  reportedBefore: boolean;
  disturbanceReason: DisturbanceReason;
  disturbanceLocation: DisturbanceLocation;
  disturbancePerson?: string;
  disturbanceArea?: string;
  /** Staircase and apartment number (e.g. "A 003", "B 025") */
  disturbanceApartment?: string;
  /** ID of the apartment that caused the disturbance */
  disturbanceApartmentId?: string;
  realEstateAddress?: string;
}
